import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROFILES } from "./apiRoutes";

const mutateToggleEmployeeStatus = async ({ id }: { id: string | number }) => {
  return await axiosAuth.patch(`${PROFILES}${id}`);
};

const useToogleEmployeeStatussMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
			id: string | number;
		},
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateToggleEmployeeStatus,
    ...queryParams,
  });

export default useToogleEmployeeStatussMutation;
